import React from "react";
import { Link, NavLink } from "react-router-dom";

const CONTACT_EMAIL = "hello@rajahussain.ai";

function Header() {
  return (
    <header className="site-header">
      <Link to="/" className="logo" aria-label="Home">
        raja hussain<span className="logo-tld">.ai</span>
      </Link>
      <nav className="site-nav">
        <NavLink
          to="/projects"
          className={({ isActive }) =>
            "nav-item" + (isActive ? " is-active" : "")
          }
        >
          Projects
        </NavLink>
        <NavLink
          to="/essays"
          className={({ isActive }) =>
            "nav-item" + (isActive ? " is-active" : "")
          }
        >
          Essays
        </NavLink>
        <NavLink
          to="/travel"
          className={({ isActive }) =>
            "nav-item" + (isActive ? " is-active" : "")
          }
        >
          Travel
        </NavLink>
        <a href={`mailto:${CONTACT_EMAIL}`} className="nav-contact">
          Contact
        </a>
      </nav>
    </header>
  );
}

export default Header;
